// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".545.0.0." + {"1367": "1ec0aabf209865b5","2257": "f061b88083a9dd7f","2973": "256fc95647d74f8e","582": "07a28605efab25d0","7530": "ba1e43aee9e655c7","7581": "45d0fc38b0002a3d","8692": "230b660e7503db94",}[chunkId] + ".css"
}